import * as React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs"; // Import dayjs

export default function ControlledComponent({
  date,
  onChange,
  update,
  isEdit = false,
}) {
  
  // Format the date to 'DD-MMM-YYYY' (e.g., 15-Jan-2025)
  const formattedDate = date ? dayjs(date).format("DD-MMM-YYYY") : null;

  console.log("formData date", date);
    const [isNothing, setIsNothing] = React.useState(false);
  
React.useEffect(()=>{
    console.log("getFirstDateOfCurrentMonthPayloadFormate ",update ," ")
    if( update){
  
    setIsNothing(true)
  }
   
   },[update ])
   if(isNothing){
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={["DatePicker"]}>
          <DatePicker
            label={`${isEdit ? "Rate " : "With "} Effective From`}
            sx={{
              width: "100%",
              "& .MuiInputBase-input": { height: "0.5rem" },
            }}
            value={date}
            onChange={(newValue) => onChange(newValue)}
            format="DD-MMM-YYYY" // Display in day-month-year format with month as text
          />
        </DemoContainer>
      </LocalizationProvider>
    );

   }
   return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DemoContainer components={["DatePicker"]}>
      <DatePicker
        label={`${isNothing ? "Rate " : "With "} Effective From`}
        sx={{
          width: "100%",
          "& .MuiInputBase-input": { height: "0.5rem" },
        }}
        value={null} // Set value as null to display an empty input field
        onChange={(newValue) => onChange(newValue)}
        format="DD-MMM-YYYY" // Display format
      />
    </DemoContainer>
  </LocalizationProvider>
   )
 
}
